// this.$store.commit("data/SET_WELCOMEVIDEOPLAYS",JSON.stringify(res.data))
import moment from 'moment'
const state = {
  phoneHeight: 0, // 手机高度,
  commonPayObj:'',       // 获取当前消费指定类型对象
  sTimeDays: moment().format("YYYY-MM"),           // 记录时间
  sObjTime:"",
  destruction: 0 
}

const mutations = {

  SET_DESTRUCTION:(state, data) => {
    state.destruction = data
  },

  SET_SOBJTIME:(state, data) => {
    state.sObjTime = data
  },

  SET_PHONEHEIGHT: (state, data) => {
    state.phoneHeight = data
  },

  SET_COMMONPAYOBJ: (state, data) => {
    state.commonPayObj = data
  },

  SET_STIMEDAYS:(state, data) => {
    state.sTimeDays = data
  },
}

const actions = {

}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}